<template>
  <div class="main-layout">
    <navbar/>

    <div class="container mt-4">
      <advertisement @updateAdCount="updateAdCount"/>
      <child/>
    </div>
  </div>
</template>

<script>
import Navbar from '~/components/Navbar'

export default {
  name: 'MainLayout',

  data: () => ({
    adcount: 0
  }),

  components: {
    Navbar
  },
  created: function () {
    this.setTheme();
  },
  methods: {
    setTheme: function () {
      const currentTheme = localStorage.getItem('theme') ? localStorage.getItem('theme') : "dark";
      if (currentTheme) {
        document.documentElement.setAttribute('data-theme', currentTheme);
      }
    },
    updateAdCount(count) {
      this.adcount = count;
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/layouts/default.vue